/* IMPORTS GO HERE */
import accessibleMenu from "../../views/organisms/header/display/accessible-menu";
import mobileMenu from "../../views/organisms/header/display/mobile-menu";
import skipLinkFocusFix from "../../views/organisms/header/display/skip-link-focus-fix";

async function init() {
  /* Load JS for blocks only if they exist on the page */
  /* https://parceljs.org/features/code-splitting/ */
  /* Accordion */
  const accordionsList = document.querySelector(".accordion");
  if (accordionsList) {
    const accordionsJS = await import(
      "../../views/organisms/blocks/accordion/display/accordion.js"
    );
    accordionsJS.render();
  }
  /* Find a Hike Map */
  const fahMapFrame = document.getElementById("fah-map");
  if (fahMapFrame) {
    const fahMapJS = await import(
      "../../views/organisms/find-a-hike/display/find-a-hike-map.js"
    );
    await fahMapJS.render();
  }
  /* Find a Hike Search */
  const fahSearch = document.getElementById("fah-search");
  if (fahSearch) {
    const fahSearchJS = await import(
      "../../views/organisms/find-a-hike/display/find-a-hike-search.js"
    );
    fahSearchJS.render();
  }
  /* People Cards */
  const peopleCardsGrid = document.querySelector(".people-cards");
  if (peopleCardsGrid) {
    const peopleCardsJS = await import(
      "../../views/organisms/blocks/people-cards/display/people-cards.js"
    );
    peopleCardsJS.render();
  }
  /* Video Element */
  const videoElement = document.querySelector(".video-container");
  if (videoElement) {
    const videoJS = await import(
      "../../views/organisms/blocks/banner/display/banner.js"
    );
    videoJS.render();
  }
  /* Modals */
  const modal = document.querySelector(".frcg-modal");
  if (modal) {
    const modalJS = await import("../../views/molecules/modal/modal.js");
    modalJS.render();
  }

  /* Global Components */
  skipLinkFocusFix();
  accessibleMenu();
  mobileMenu();
}

/* Initialize Site Scripts */
init();
